import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

const Home = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;

  // Fix the interval issue
  const [count, setCount] = useState(0);
  useEffect(() => {
    const delay = 360000;
    const interval = setInterval(() => {
      setCount(prev => prev + 1);
    }, delay);
    return () => clearInterval(interval);
  }, []);

  const [newsItems, setNewsItems] = useState([]);
  const [expandedNews, setExpandedNews] = useState({});
  const [currentMemberIndex, setCurrentMemberIndex] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const heroRef = useRef(null);
  const statsRef = useRef([]);

  // Parallax effect for hero section
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (heroRef.current) {
        const { left, top, width, height } = heroRef.current.getBoundingClientRect();
        const x = ((e.clientX - left) / width - 0.5) * 20;
        const y = ((e.clientY - top) / height - 0.5) * 20;
        setMousePosition({ x, y });
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Counter animations
  useEffect(() => {
    statsRef.current.forEach((ref, index) => {
      if (ref) {
        const target = parseInt(ref.getAttribute('data-target'));
        const duration = 2000;
        const steps = 60;
        const increment = target / steps;
        let current = 0;

        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }
          ref.textContent = Math.floor(current) + (index === 0 ? '+' : '');
        }, duration / steps);
      }
    });
  }, []);

  const fetchNews = async () => {
    const formData = new FormData();
    formData.append('apiType', 'get-main-news');
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setNewsItems(response.data);
    } catch (error) {
      console.log('An error occurred while retrieving news items.');
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const toggleContentLatestNews = (index) => {
    setExpandedNews(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const members = [
    { name: 'Pastor Mainza Shimunzhila', role: 'Youth Director', img: 'pastor mainza shimunzhila.jpeg' },
    { name: 'MG/SYL Lameck Chimula', role: 'Chairperson', img: 'lameck chimula.jpg' },
    { name: 'MG/SYL Heather Hanene', role: 'Vice Chairperson', img: 'heather khulekeni.jpeg' },
    { name: 'MG/SYL Mutinta Muyeeka', role: 'Executive Secretary', img: 'mutinta muyeeka.jpg' },
    { name: 'MG/SYL Moses Shabuwe', role: 'Vice Secretary', img: 'moses shabuwe.jpg' },
    { name: 'MG/SYL Chimba Mutale', role: 'Treasurer', img: 'chimba mutale.jpg' },
    { name: 'MG/SYL Nanalisa Bwani', role: 'Vice Treasurer', img: 'nanalisa.jpeg' },
    { name: 'MG/SYL Paulsen Tembo', role: 'Planning Chairperson', img: 'paulsen tembo.jpg' },
    { name: 'MG/SYL Henry Mweemba', role: 'Projects Coordinator', img: 'henry mweemba.jpg' },
    { name: 'MG/SYL Bruno Nyambe', role: 'Communications Chairperson', img: 'bruno nyambe.jpg' },
    { name: 'MG/SYL Akufuna', role: 'Parliamentarian', img: 'akufuna.jpg' },
    { name: 'MG/SYL Agripa Kaanga', role: 'Education And Standards Chairperson', img: 'agripa kaanga.jpg' },
    { name: 'MG/SYL Beston Zulu', role: 'Chaplain', img: '' }
  ];

  const ministries = [
    { name: 'Adventurers', color: 'from-rose-900 to-pink-700', icon: '🏕️', count: 45 },
    { name: 'Pathfinders', color: 'from-amber-500 to-orange-600', icon: '🥾', count: 68 },
    { name: 'Ambassadors', color: 'from-cyan-500 to-blue-600', icon: '🤝', count: 32 },
    { name: 'Young Adults', color: 'from-indigo-900 to-blue-800', icon: '👨‍🎓', count: 120 },
    { name: 'PCM', color: 'from-purple-600 to-indigo-700', icon: '🙏', count: 89 }
  ];

  return (
     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
        <Header />
        
        {/* Hero Section */}
        <div 
          className="relative h-screen bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${server_app_api_php}/resources/images/wc%20logo2.webp)`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/80"></div>
          <div className="relative h-full flex flex-col justify-center items-center px-4">
            <div className="text-center max-w-6xl mx-auto animate-fade-in">
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 font-serif tracking-tight">
                WOODLANDS CONFERENCE
              </h1>
              <div className="w-32 h-1 bg-gradient-to-r from-amber-400 to-pink-500 mx-auto mb-8"></div>
              <h2 className="text-2xl md:text-3xl font-semibold text-white/90 mb-12">
                ADVENTIST YOUTH MINISTRIES
              </h2>
              
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-4xl mx-auto">
                {[
                  { name: 'Adventurers', color: 'bg-rose-900 hover:bg-rose-800', href: 'Adventurers' },
                  { name: 'Pathfinders', color: 'bg-amber-500 hover:bg-amber-600', href: 'Pathfinders' },
                  { name: 'Ambassadors', color: 'bg-cyan-500 hover:bg-cyan-600', href: 'Ambassadors' },
                  { name: 'Young Adults', color: 'bg-indigo-900 hover:bg-indigo-800', href: 'YoungAdults' },
                  { name: 'PCM', color: 'bg-purple-600 hover:bg-purple-700', href: 'PCM' }
                ].map((item, idx) => (
                  <a
                    key={idx}
                    href={item.href}
                    className={`${item.color} text-white px-4 py-4 rounded-xl transform transition-all duration-300 hover:scale-105 hover:shadow-2xl font-semibold text-center flex items-center justify-center gap-2`}
                  >
                    <span>{item.name}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
          
          {/* Scroll Indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/70 rounded-full mt-2"></div>
            </div>
          </div>
        </div>

      <main className="max-w-7xl mx-auto px-4 py-16">
        {/* Executive Members - 3D Carousel */}
        <section className="mb-32">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-16 relative">
            <span className="relative inline-block">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">
                EXECUTIVE LEADERSHIP TEAM
              </span>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-48 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-full"></div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-48 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-full blur"></div>
            </span>
          </h2>

          <div className="relative">
            {/* Carousel Navigation */}
            <div className="flex justify-center gap-4 mb-8">
              <button 
                onClick={() => setCurrentMemberIndex(prev => (prev - 1 + members.length) % members.length)}
                className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 text-white flex items-center justify-center hover:scale-110 transition-transform duration-300 shadow-lg"
              >
                ←
              </button>
              <button 
                onClick={() => setCurrentMemberIndex(prev => (prev + 1) % members.length)}
                className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white flex items-center justify-center hover:scale-110 transition-transform duration-300 shadow-lg"
              >
                →
              </button>
            </div>

            {/* 3D Carousel */}
            <div className="relative h-[500px] perspective-1000">
              {members.map((member, idx) => {
                const distance = Math.abs(idx - currentMemberIndex);
                const isActive = idx === currentMemberIndex;
                const isPrev = idx === (currentMemberIndex - 1 + members.length) % members.length;
                const isNext = idx === (currentMemberIndex + 1) % members.length;

                return (
                  <div
                    key={idx}
                    className={`absolute top-0 left-1/2 transform -translate-x-1/2 transition-all duration-700 ease-in-out ${
                      isActive ? 'z-30 scale-100 opacity-100' :
                      isPrev ? 'z-20 -translate-x-64 scale-90 opacity-70 -rotate-y-12' :
                      isNext ? 'z-20 translate-x-64 scale-90 opacity-70 rotate-y-12' :
                      'z-10 scale-75 opacity-0'
                    }`}
                    style={{ width: '300px' }}
                  >
                    <div className="group relative">
                      {/* Card Glow */}
                      <div className={`absolute -inset-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-2xl blur transition duration-1000 group-hover:opacity-75 ${
                        isActive ? 'opacity-50' : 'opacity-0'
                      }`}></div>
                      
                      <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-500 group-hover:scale-105">
                        <div className="p-8">
                          {/* Animated Avatar */}
                          <div className="relative w-48 h-48 mx-auto mb-6">
                            {/* Outer Glow Ring */}
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-spin-slow blur-md opacity-50"></div>
                            {/* Inner Ring */}
                            <div className="absolute inset-4 bg-gradient-to-r from-amber-400 to-pink-500 rounded-full animate-gradient bg-[length:200%_auto]"></div>
                            {/* Image */}
                            <img
                              src={`${server_app_api_php}/resources/images/${member.img}`}
                              className="relative w-full h-full rounded-full object-cover border-4 border-white shadow-xl"
                              alt={member.name}
                              onError={(e) => {
                                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=random&color=fff&size=256`;
                              }}
                            />
                            {/* Badge */}
                            <div className="absolute -bottom-2 -right-2 bg-gradient-to-r from-amber-400 to-pink-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                              EXEC
                            </div>
                          </div>
                          
                          {/* Name with Gradient Text */}
                          <h3 className="text-2xl font-bold text-center mb-3 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">
                            {member.name}
                          </h3>
                          
                          {/* Role with Animated Border */}
                          <div className="relative inline-block mx-auto">
                            <p className="relative z-10 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                              {member.role}
                            </p>
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur opacity-50 animate-pulse"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Carousel Dots */}
            <div className="flex justify-center gap-2 mt-8">
              {members.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentMemberIndex(idx)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    idx === currentMemberIndex 
                      ? 'w-8 bg-gradient-to-r from-blue-500 to-purple-500' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Animated Bible Verse Section */}
        <div className="relative py-32 mb-32 overflow-hidden rounded-3xl group">
          {/* Animated Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 via-purple-600/10 to-pink-600/10 animate-gradient bg-[length:400%_400%]"></div>
          
          {/* Floating Elements */}
          <div className="absolute inset-0 overflow-hidden">
            {[...Array(15)].map((_, i) => (
              <div
                key={i}
                className="absolute text-4xl opacity-10 animate-float"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 5}s`,
                  animationDuration: `${Math.random() * 15 + 10}s`
                }}
              >
                ✝️
              </div>
            ))}
          </div>

          {/* Animated Border */}
          <div className="absolute inset-0 rounded-3xl border-2 border-transparent bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-[length:200%_200%] animate-gradient group-hover:bg-[length:400%_400%] transition-all duration-700 -m-2"></div>

          <div className="relative max-w-4xl mx-auto text-center px-4">
            {/* Animated Icon */}
            <div className="inline-block mb-12 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur-xl opacity-50 animate-pulse"></div>
              <div className="relative w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center transform group-hover:rotate-180 transition-transform duration-700">
                <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
            </div>

            {/* Typewriter Effect Quote */}
            <blockquote className="text-3xl md:text-4xl lg:text-5xl font-serif text-gray-800 italic mb-8 leading-relaxed relative">
              <span className="relative">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600">
                  "I can do all things through Christ who strengthens me."
                </span>
                <span className="absolute -right-6 top-0 w-1 h-full bg-gradient-to-b from-blue-500 to-purple-500 animate-pulse"></span>
              </span>
            </blockquote>
            
            {/* Reference with Glow */}
            <p className="text-xl text-gray-600 font-medium relative inline-block">
              <span className="relative z-10">~ Philippians 4:13 ~</span>
              <span className="absolute inset-0 text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 blur-xl opacity-50">
                ~ Philippians 4:13 ~
              </span>
            </p>

            {/* Animated Dots */}
            <div className="mt-12 flex justify-center gap-6">
              {['💙', '💜', '❤️', '🧡', '💚'].map((emoji, idx) => (
                <div
                  key={idx}
                  className="text-2xl animate-bounce"
                  style={{ animationDelay: `${idx * 0.1}s` }}
                >
                  {emoji}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* News Section with Glass Morphism */}
        <section className="mb-32">
          <div className="flex items-center justify-between mb-12">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 relative">
                <span className="relative">
                  Latest News
                  <div className="absolute -bottom-2 left-0 w-48 h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
                  <div className="absolute -bottom-2 left-0 w-48 h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur"></div>
                </span>
              </h2>
              <p className="text-gray-600">Stay updated with our latest activities and events</p>
            </div>
            
            <button className="hidden md:flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-3 rounded-full hover:shadow-xl transform hover:scale-105 transition-all duration-300">
              <span>View All News</span>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {newsItems.map((news, index) => (
              <div key={index} className="group relative">
                {/* Glass Morphism Card */}
                <div className="relative bg-white/80 backdrop-blur-lg rounded-3xl shadow-xl overflow-hidden transform transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl">
                  {/* Gradient Border Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500/0 via-purple-500/0 to-pink-500/0 group-hover:from-blue-500/10 group-hover:via-purple-500/10 group-hover:to-pink-500/10 transition-all duration-700"></div>
                  
                  <div className="relative">
                    {/* Media Section */}
                    <div className="relative h-64 md:h-80 overflow-hidden">
                      {news.media_urlsVideos.length < 1 && news.media_urlsImages.length > 0 ? (
                        <img
                          src={server_app_api_php + '/server/' + news.media_urlsImages[0]}
                          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                          alt="News"
                        />
                      ) : news.media_urlsVideos.length > 0 ? (
                        <video
                          className="w-full h-full object-cover"
                          controls
                          poster={`${server_app_api_php}/resources/images/thumbnail.jpg`}
                        >
                          <source src={server_app_api_php + '/server/' + news.media_urlsVideos[0]} />
                        </video>
                      ) : (
                        <div className="w-full h-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                          <span className="text-white text-4xl">📰</span>
                        </div>
                      )}
                      
                      {/* Overlay Gradient */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      
                      {/* Badge */}
                      <div className="absolute top-6 left-6">
                        <span className="bg-gradient-to-r from-amber-400 to-pink-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg flex items-center gap-2">
                          <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
                          Breaking News
                        </span>
                      </div>
                      
                      {/* Date */}
                      <div className="absolute bottom-6 left-6 bg-black/50 backdrop-blur-sm text-white px-4 py-2 rounded-full">
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                          </svg>
                          <span>{new Date().toLocaleDateString('en-US', { 
                            weekday: 'long', 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                          })}</span>
                        </div>
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="p-8">
                      <h3 className="text-2xl font-bold text-gray-800 mb-4 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-purple-600 transition-all duration-300">
                        {news.title}
                      </h3>
                      
                      <p className="text-gray-600 mb-6 leading-relaxed">
                        {expandedNews[index] ? news.description : news.description.split(' ').slice(0, 40).join(' ')}
                        {news.description.split(' ').length > 40 && (
                          <button
                            onClick={() => toggleContentLatestNews(index)}
                            className="ml-2 font-semibold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 transition-all duration-300"
                          >
                            {expandedNews[index] ? 'Show Less' : 'Read More →'}
                          </button>
                        )}
                      </p>

                      {/* Media Gallery */}
                      {expandedNews[index] && (
                        <div className="mt-8 space-y-6">
                          <div className="grid grid-cols-2 gap-4">
                            {news.media_urlsImages.slice(1, 3).map((urlImage, indexImage) => (
                              <div key={indexImage} className="relative group/image">
                                <img
                                  src={server_app_api_php + '/server/' + urlImage}
                                  alt={`News ${indexImage + 1}`}
                                  className="rounded-xl shadow-md w-full h-48 object-cover transform group-hover/image:scale-105 transition-transform duration-500"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-xl opacity-0 group-hover/image:opacity-100 transition-opacity duration-300"></div>
                              </div>
                            ))}
                          </div>
                          
                          {news.media_urlsVideos.slice(1).map((urlVideo, indexVideo) => (
                            <div key={indexVideo} className="relative">
                              <video
                                className="rounded-xl shadow-md w-full"
                                controls
                              >
                                <source src={server_app_api_php + '/server/' + urlVideo} />
                              </video>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Tags */}
                      <div className="flex flex-wrap gap-2 mt-6">
                        <span className="px-3 py-1 bg-blue-100 text-blue-600 rounded-full text-sm">Youth</span>
                        <span className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-sm">Ministry</span>
                        <span className="px-3 py-1 bg-pink-100 text-pink-600 rounded-full text-sm">Event</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Load More Button */}
          <div className="text-center mt-12">
            <button className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-4 rounded-full hover:shadow-2xl transform hover:scale-105 transition-all duration-300 overflow-hidden">
              <span className="relative z-10">Load More News</span>
              <svg className="w-5 h-5 relative z-10 transform group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}

export default Home;